import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h1 
            className="text-3xl font-semibold text-zinc-900 mb-8"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            data-testid="privacy-title"
          >
            Politique de confidentialité
          </h1>

          <div className="bg-white border border-zinc-200 rounded-xl p-8 prose prose-zinc max-w-none">
            <h2>1. Collecte des données</h2>
            <p>
              JobMatch CV collecte les données suivantes :
            </p>
            <ul>
              <li>Informations de compte : nom, email, mot de passe (chiffré)</li>
              <li>Documents téléchargés : CV et offres d'emploi (traités puis supprimés)</li>
              <li>Données d'analyse : scores et résultats générés par l'IA</li>
            </ul>

            <h2>2. Utilisation des données</h2>
            <p>
              Vos données sont utilisées uniquement pour :
            </p>
            <ul>
              <li>Fournir les services d'analyse CV</li>
              <li>Améliorer la qualité de nos algorithmes</li>
              <li>Vous contacter concernant votre compte</li>
            </ul>

            <h2>3. Protection des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données :
            </p>
            <ul>
              <li>Chiffrement des mots de passe</li>
              <li>Connexions sécurisées (HTTPS)</li>
              <li>Accès limité aux données personnelles</li>
            </ul>

            <h2>4. Partage des données</h2>
            <p>
              Nous ne vendons ni ne partageons vos données personnelles avec des tiers, 
              sauf obligation légale ou avec votre consentement explicite.
            </p>

            <h2>5. Conservation des données</h2>
            <p>
              Vos données sont conservées tant que votre compte est actif. 
              Vous pouvez demander la suppression de vos données à tout moment.
            </p>

            <h2>6. Vos droits</h2>
            <p>
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul>
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit à la portabilité</li>
            </ul>

            <h2>7. Contact</h2>
            <p>
              Pour toute question concernant vos données, contactez-nous à : 
              <a href="mailto:contact@jobmatch-cv.com">contact@jobmatch-cv.com</a>
            </p>

            <p className="text-sm text-zinc-500 mt-8">
              Dernière mise à jour : Janvier 2026
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
